import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {FormControl, FormsModule} from "@angular/forms";
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-filter-tags',
  standalone: true,
  imports: [
    FormsModule,
    NgIf,
    NgForOf
  ],
  templateUrl: './filter-tags.component.html',
  styleUrl: './filter-tags.component.scss'
})
export class FilterTagsComponent implements OnInit {

  @Input() control!: FormControl;
  @Input() required: boolean = false;
  @Input() placeholder: string = '';
  @Input() showlabel: boolean = true;

  @ViewChild('tagInput') tagInput!: ElementRef<HTMLInputElement>;

  tags: string[] = [];
  inputValue: string = '';
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  ngOnInit() {
    // Initialize from existing control value if it exists
    this.syncFromControlValue();

    // Subscribe to control value changes from outside
    this.control.valueChanges.subscribe(value => {
      if (value !== null && !this.areArraysEqual(this.tags, value)) {
        this.syncFromControlValue();
      }
    });
  }

  private syncFromControlValue() {
    if (this.control.value) {
      if (Array.isArray(this.control.value)) {
        this.tags = [...this.control.value];
      } else if (typeof this.control.value === 'string') {
        this.tags = this.control.value.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
      }
    } else {
      this.tags = [];
    }
  }

  private areArraysEqual(arr1: string[], arr2: string[] | any): boolean {
    if (!Array.isArray(arr2)) return false;
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, i) => item === arr2[i]);
  }

  handleKeydown(event: KeyboardEvent): void {
    // Check if Enter or comma key was pressed
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      this.addTag();
    }
  }

  addTag(): void {
    const value = this.inputValue.trim();

    // Add tag if value exists and isn't a duplicate
    if (value && !this.tags.includes(value)) {
      this.tags.push(value);
      this.updateControlValue();
    }

    // Reset the input value
    this.inputValue = '';
  }

  addTagFromInput(): void {
    this.addTag();
  }

  removeTag(index: number): void {
    this.tags.splice(index, 1);
    this.updateControlValue();
  }

  private updateControlValue(): void {
    // Always set a new array to prevent reference issues
    this.control.setValue([...this.tags]);
    this.control.markAsDirty();
  }

}
